<template>
  <div class="">
    <el-page-header class="page-header" @back="fanhui" content="审批步骤" >
      </el-page-header>
    
    <div class="Mmain"  >
      <nav>
        <span class="shij">
          <!-- <el-button
            @click="fanhui()"
            icon="el-icon-back"
            style="margin-right: 2rem"
          >
            返回
          </el-button> -->
          <el-button
            @click="(onSubmit = true), tianjia()"
            icon="el-icon-plus"
            type="primary"
          >
            添加
          </el-button>
        </span>
      </nav>
      <el-table
        border
        height="600"
        :data="tableData"
        v-loading="tableLoading"
      >
        <el-table-column
          prop="order_id"
          label="排序"
          style="width: 10%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="user_name"
          label="员工名称"
          style="width: 10%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="apply_item_name"
          label="事项名称"
          style="width: 20%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createtime"
          label="创建时间"
          style="width: 20%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="updatetime"
          label="修改时间"
          style="width: 20%"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" min-width="100"  fixed="right" >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="(onSubmitn = true), bianji(scope.row)"
              >修改</el-button
            >
            <el-button
              size="mini"
              type="text"
              @click="handleClick(scope.row)"
              style="color:#f00000 !important"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      :page-sizes="[10,20,50,100]"
      :auto-scroll="false"
      @pagination="userTable"
    />
    <el-dialog title="添加" center :visible.sync="onSubmit" width="25%">
      <el-form ref="form" :rules="rules" :model="form" label-width="8rem">
        <el-form-item label="审批人">
          <input type="hidden" v-model="name">
          <div class="shenpi" style="width:25rem;" @click="addContact" >{{ name }}</div>
        </el-form-item>
        <el-form-item label="排序" >
          <el-input  clearable style="width:25rem;" v-model="form.group_name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit = false">取 消</el-button>
        <el-button type="primary" @click="numoo()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改" center :visible.sync="onSubmitn" width="25%">
      <el-form ref="form" :rules="rules" :model="form" label-width="8rem">
        <el-form-item label="审批人">
          <div class="shenpi" style="width:25rem;" @click="addContact">{{ name }}</div>
        </el-form-item>
        <el-form-item label="排序">
          <el-input clearable style="width:25rem;" v-model="form.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitn = false">取 消</el-button>
        <el-button type="primary" @click="numoon()">确 定</el-button>
      </span>
    </el-dialog>
    <right-people ref="dialog" :checkbox="checkbox" :isGroup="isGroup" @handleSelect="handleSelect"></right-people>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
import rightPeople from '@/components/drawer/rightPeople';
export default {
  name: "monitoring",
  components: {
    Pagination,
    rightPeople
  },
  data() {
    return {
      tableData: [],
      botom: {},
      input2: "",
      onSubmit: false,
      onSubmitn: false,
      tableData_a: [],
      options: [],
      value3: "",
      value2: "",
      multipleSelection: [],
      value1: true,
      form: {
        name: "",
        group_name: "",
        tag_name: "",
      },
      ele: "",
      yeshu: 1,
      bianjile: "",
      pageSize: "",
      rules: {
        name: [{ required: true, message: "请输入新增名称", trigger: "blur" }],
        group_name: [
          { required: true, message: "请输入分组名称", trigger: "blur" },
        ],
        tag_name: [{ required: true, message: "请输入标签", trigger: "blur" }],
      },
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      checkbox: false,
      isGroup: false,
      module: "",
      selectionDepartment: true,
      selectionName: true,
      name: "",
      value: "",
      tableLoading: true,
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据 http://192.168.0.149/api/Prive/getPriveList
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }

    this.botom = this.$route.query.val;
    this.userTable();
  },
  methods: {
    fanhui() {
      this.$router.push("/register/user/applys");
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    tongbu() {
      this.axios
        .post(
          "/crm/Assistant/get_tag",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.userTable();
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    //  页数
    handleCurrentChange(val) {
      this.pageSize = val;
      this.userTable();
    },
    userTable() {
      this.axios
        .post(
          "/crm/ApplyStep/getList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            apply_item_id: this.botom.id,
            page: this.listQuery.page,
            number_page:this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.tableLoading = false;
          this.total = res.data.count
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
      this.axios
        .post(
          "/crm/KpiSet/getKpiUsers",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.options = res.data.data;
        })
        .catch(function (err) {});
    },
    rune() {
      this.userTable();
    },
    tianjia() {
      this.name = "";
      this.value = "";
      this.form.group_name = "";
    },

    handleSelectionChange(val) {
      this.yeshu = 1;
      this.multipleSelection = val;
    },
    bianji(e) {
      this.ele = e;
      this.form.name = e.order_id.toString();
      this.value2 = e.userid;
      this.name = e.user_name;
      this.value = e.userid;
    },
    // 修改
    numoon() {
      if(this.name.trim() == ""){
        this.$message.error('审批人不能为空');
        return
      }
      if(this.form.name.trim() == ""){
        this.$message.error('排序不能为空');
        return
      }
      this.axios
        .post(
          "/crm/ApplyStep/editStep",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            userid: this.value,
            id: this.ele.id,
            order_id: this.form.name,
            apply_item_id: this.ele.apply_item_id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmitn = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.userTable();
          } else if (res.data.code == 0) {
            this.onSubmitn = true;
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    // 添加
    numoo() {
      if(this.name == undefined||this.name.trim() == ""){
        this.$message.error('审批人不能为空');
        return
      }
      if(this.form.group_name.trim() == ""){
        this.$message.error('排序不能为空');
        return
      }
      if(!Number(this.form.group_name)){
          this.$message.error('排序不能为非数字');
          return
        }
      this.axios
        .post(
          "/crm/ApplyStep/addStep",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            apply_item_id: this.botom.id,
            order_id: this.form.group_name,
            userid: this.value,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.userTable();
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    // 移除
    handleClick(e) {
      this.yeshu = 1;
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/ApplyStep/delStep",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                id: e.id,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
              this.userTable();
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.tableData_a = res.data.data;
            })
            .catch(function (err) {});
        })
        .catch(() => {});
    },
    addContact() {
      this.module = "getAddressBook";
      this.isGroup = true;
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      this.value = person.userid;
      this.name = person.name;
    },
  },
};
</script>
<style scoped>
.hello {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  -webkit-box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
  overflow-y: auto;
}
nav {
  width: 100%;
}
.shij {
  display: inline-block;
  margin-right: 2.4rem;
}
.shenpi {
  /*width: 25rem !important;*/
  height: 4rem;
  border: .1rem solid #dcdfe6;
  padding: 0 1.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: .4rem;
  padding-right: 1.5625vw;
}
.Mmain{
    width: 100%;
    padding: 3rem;
    background: #fff;
    border-radius: .8rem;
}
.page-header{
  position: relative;
  top: -0.4rem;
}
</style>
